import React from 'react';
import ToolSectionTitle from 'components/Tools/ToolSectionTitle';
import SwitchButton from 'components/common/SwitchButton';
import { useStore, StoreTypes } from 'context';
import { EventBus } from 'events/EventBus';
import { ReaderToolsEvent } from 'events/EventTypes';
import { useGAEvent } from 'components/AppService/GAService';

const OptimizePerformance = () => {
  const { gaEvent } = useGAEvent();
  const [{ optimizePerformance }] = useStore(StoreTypes.reader);

  const onChangeHandler = val => {
    gaEvent('偏好設定_便利貼內容預覽_' + (val ? '開' : '關'));
    EventBus.emit({ event: ReaderToolsEvent.SetOptimizePerformance, payload: { optimizePerformance: val } })
  }
  
  return (
    <div>
      <ToolSectionTitle label="便利貼內容預覽" />
      <SwitchButton value={optimizePerformance} onChange={val=>onChangeHandler(val)}/>
    </div>
  )
};

export default OptimizePerformance;
